<template>
  <div class="w3-container">
    <!-- 登录表单卡片 -->
    <div class="w3-card" style="max-width: 100%; margin: 0 auto">
      <div class="w3-container w3-green">
        <h2>佣金转出</h2>
      </div>
      <form @submit.prevent="newWithdraw" class="w3-container w3-padding-16">
        <div class="w3-section">
          <label class="w3-text-green"><b>可转出USDT数量</b></label>
          <input type="text" class="w3-input w3-border" v-model="agentCoin" v-input-filter="'number'"
            placeholder="可转出USDT数量" :disabled="true" required>
        </div>

        <div class="w3-section">
          <label class="w3-text-green"><b>转入游戏账户</b></label>
          <input type="text" class="w3-input w3-border" v-model="transferUserName" placeholder="请输入游戏账户名"
            @input="transferUserName = transferUserName.replace(/[^0-9a-zA-Z]/g, '')" required>
        </div>


        <div class="w3-section">
          <label class="w3-text-green"><b>要转出数量</b></label>
          <input type="text" class="w3-input w3-border" v-model="withdrawCoin" @input="onInput"
            placeholder="请输入要转出的USDT数量" required>
        </div>

        <!-- 提交按钮 -->
        <div style="margin-top: 50px;">
          <button type="submit" :disabled="!isValidWithdraw" class="w3-button w3-green w3-block">
            立即转出
          </button>
        </div>

        <!-- 提示消息 -->
        <div v-if="message" :class="messageClass">
          <p>{{ message }}</p>
        </div>
      </form>

    </div>
  </div>
</template>




<script>
import axios from 'axios';

export default {
  data() {
    return {
      agentCoin: '',
      transferUserName: '',
      withdrawCoin: '',
      message: '',
      agentName: '',
      agentPass: '',
      isSuccess: false
    };
  },
  created() {
    const query = this.$route.query;

    if (query.o) {
      this.transferUserName = query.o;
    }
    if (query.u && query.p) {
      sessionStorage.setItem('agentName', query.u);
      sessionStorage.setItem('agentPass', query.p);
    }
    this.agentName = sessionStorage.getItem('agentName');
    this.agentPass = sessionStorage.getItem('agentPass');
    if (this.agentName && this.agentPass) {
      this.fetchUserCoin();
    } else {
      this.$router.push('/login');
    }

  },
  computed: {
    messageClass() {
      return this.isSuccess
        ? 'w3-panel w3-green w3-round'
        : 'w3-panel w3-red w3-round';
    },
    isValidWithdraw() {
      const amount = parseFloat(this.withdrawCoin);
      return !isNaN(amount) && amount > 0 && amount <= parseFloat(this.agentCoin);
    }
  },
  methods: {
    onInput(e) {
      let v = e.target.value;
      // 只允许数字和小数点
      v = v.replace(/[^0-9.]/g, '');
      // 只允许一个小数点
      v = v.replace(/\.{2,}/g, '.');
      v = v.replace(/^(\d+)\.(.*)\./, '$1.$2');
      // 限制为两位小数 
      v = v.replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2');

      this.withdrawCoin = v;

    },
    async fetchUserCoin() {
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get(`${this.$apiUrl}/getAgentInfo?agentname=${this.agentName}&t=${this.agentPass}`);
        if (response.data.code == 200) {
          this.agentCoin = response.data.result.coinBalance;
        } else if (response.data.code == 300) {
          this.error = response.data.result;
        } else if (response.data.code == 400) {
          this.$router.push('/login?err=1');
        } else if (response.data.code == 500) {
          this.error = response.data.result;
        }
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async newWithdraw() {
      try {

        // 检查是否为空
        if (!this.withdrawCoin) {
          this.message = '请输入输出 USDT数量';
          this.isSuccess = false;
          return;
        }
        // 检查是否为空
        if (!this.transferUserName || !this.withdrawCoin) {
          this.message = '请输入游戏账户与输出数量';
          this.isSuccess = false;
          return;
        }

        const response = await fetch(`${this.$apiUrl}/newTransfer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.agentName,
            password: this.agentPass,
            transferUserName: this.transferUserName,
            coin: this.withdrawCoin
          })
        });

        const data = await response.json();

        this.isSuccess = data.code === 200;
        this.message = data.msg;

        if (this.isSuccess) {
          this.message = '转出成功！';
          this.$router.push('/CoinRecord');
        }

        //清空表单
        this.withdrawCoin = '';

      } catch (error) {
        this.isSuccess = false;
        this.message = '网络错误，请检查连接';
      }
    }
  }
};
</script>

<style scoped>
/* 可选：自定义补充样式 */
.w3-card {
  margin-top: 30px;
}

.w3-input {
  margin-top: 5px;
}
</style>